import React from "react";
import { ValidationResult } from "../types/validation";
import "./ValidationStatusBar.css";

interface ValidationStatusBarProps {
  validation: ValidationResult | null;
  className?: string;
}

const ValidationStatusBar: React.FC<ValidationStatusBarProps> = ({
  validation,
  className = "",
}) => {
  if (!validation) return null;

  const hasErrors = validation.errors.length > 0;
  const hasWarnings = validation.warnings.length > 0;
  const hasSuggestions = validation.suggestedActions.length > 0;

  if (!hasErrors && !hasWarnings && !hasSuggestions) return null;

  return (
    <div className={`validation-status-bar ${className}`}>
      {/* Errors Section */}
      {hasErrors && (
        <div className="validation-section validation-errors">
          <div className="validation-header">
            <span className="validation-icon">❌</span>
            <span className="validation-title">Validation Errors</span>
          </div>
          <ul className="validation-list">
            {validation.errors.map((error, index) => (
              <li key={index} className="validation-item error">
                {error}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Warnings Section */}
      {hasWarnings && (
        <div className="validation-section validation-warnings">
          <div className="validation-header">
            <span className="validation-icon">⚠️</span>
            <span className="validation-title">Warnings</span>
          </div>
          <ul className="validation-list">
            {validation.warnings.map((warning, index) => (
              <li key={index} className="validation-item warning">
                {warning}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Suggested Actions Section */}
      {hasSuggestions && (
        <div className="validation-section validation-suggestions">
          <div className="validation-header">
            <span className="validation-icon">💡</span>
            <span className="validation-title">Suggested Actions</span>
          </div>
          <ul className="validation-list">
            {validation.suggestedActions.map((action, index) => (
              <li key={index} className="validation-item suggestion">
                {action}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ValidationStatusBar;
